// zod helpers for form fields. Inputs always hold strings; these turn '' into null and validate.
import { z } from 'zod';

export const optionalText = (max = 200) =>
  z
    .string()
    .trim()
    .max(max, `Keep it under ${max} characters.`)
    .transform((value) => (value === '' ? null : value));

export const optionalNumber = (min: number, max: number, message: string) =>
  z
    .string()
    .trim()
    .refine((value) => value === '' || (/^\d+([.,]\d+)?$/.test(value) && Number(value.replace(',', '.')) >= min && Number(value.replace(',', '.')) <= max), message)
    .transform((value) => (value === '' ? null : Number(value.replace(',', '.'))));

export const optionalPastDate = z
  .string()
  .refine((value) => value === '' || (/^\d{4}-\d{2}-\d{2}$/.test(value) && value <= new Date().toISOString().slice(0, 10)), 'Choose a date that isn’t in the future.')
  .transform((value) => (value === '' ? null : value));

export const optionalTime = z
  .string()
  .refine((value) => value === '' || /^([01]\d|2[0-3]):[0-5]\d$/.test(value), 'Use a time like 08:30.')
  .transform((value) => (value === '' ? null : value));

/** Value for an <input> from a stored value. */
export const inputValue = (value: string | number | null | undefined) => (value == null ? '' : String(value));
